module.exports = __webpack_public_path__ + "img/ico-scheduled.74a5b3e5.svg";